var _class, _TrainerPane;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { withTheme } from "styled-components";
import styled from "styled-components";
import StyledHtml from "./StyledHtml";
import Box, { BoxSpan } from "../../../../Styled/Box";
import Button from "../../../../Styled/Button";
import Spacing from "../../../../Styled/Spacing";
import Text from "../../../../Styled/Text";
import { applyTranslationIfExists } from "../../../../Language/languageHelpers";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const UlTrainerItems = styled(Box).attrs({
  as: "ul"
}).withConfig({
  displayName: "TrainerPane__UlTrainerItems",
  componentId: "sc-16dbt2t-0"
})(["", ""], p => p.theme.removeListStyles());
const TrainerButton = styled(Button).withConfig({
  displayName: "TrainerPane__TrainerButton",
  componentId: "sc-16dbt2t-1"
})([""]);
let TrainerPane = observer(_class = (_TrainerPane = class TrainerPane extends Component {
  render() {
    const {
      content,
      i18n,
      viewState
    } = this.props;
    const {
      trainerItems,
      markdownText
    } = content;
    return /*#__PURE__*/_jsx(Text, {
      textDark: true,
      noFontSize: true,
      children: /*#__PURE__*/_jsxs(Box, {
        column: true,
        children: [markdownText && /*#__PURE__*/_jsx(StyledHtml, {
          viewState: viewState,
          markdown: markdownText
        }), (trainerItems === null || trainerItems === void 0 ? void 0 : trainerItems.map) && /*#__PURE__*/_jsx(UlTrainerItems, {
          column: true,
          fullWidth: true,
          justifySpaceBetween: true,
          children: trainerItems.map((item, index) => /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx(TrainerButton, {
              secondary: true,
              fullWidth: true,
              onClick: () => {
                viewState.hideHelpPanel();
                viewState.setSelectedTrainerItem(content.itemName);
                viewState.setCurrentTrainerItemIndex(index);
                viewState.setTrainerBarVisible(true);
              },
              children: /*#__PURE__*/_jsx(BoxSpan, {
                centered: true,
                children: /*#__PURE__*/_jsx(BoxSpan, {
                  centered: true,
                  children: applyTranslationIfExists(item.title, i18n)
                })
              })
            }), /*#__PURE__*/_jsx(Spacing, {
              bottom: 2
            })]
          }, index))
        })]
      })
    });
  }
}, _defineProperty(_TrainerPane, "displayName", "TrainerPane"), _defineProperty(_TrainerPane, "propTypes", {
  viewState: PropTypes.object.isRequired,
  content: PropTypes.object.isRequired,
  t: PropTypes.func,
  i18n: PropTypes.object.isRequired
}), _TrainerPane)) || _class;
export default withTranslation()(withTheme(TrainerPane));